/** Map Supabase/Postgres failures to user-facing messages for join and round ops. */

function lower(msg: string | undefined): string {
  return (msg || '').toLowerCase();
}

function isMissingJoinRequests(msg: string): boolean {
  return msg.includes('request_group_round_join')
    || msg.includes('respond_group_round_join')
    || msg.includes('group_round_join_requests');
}

function isMissingLiveDeleteJoin(msg: string): boolean {
  return (msg.includes('join_group_round') || msg.includes('join_game')) && msg.includes('does not exist')
    || msg.includes('could not find the function')
    || msg.includes('schema cache');
}

export function formatJoinError(rpcMessage: string | undefined, fallbackMessage: string): string {
  const msg = lower(rpcMessage || fallbackMessage);
  if (isMissingJoinRequests(msg)) {
    return 'Request-to-join is not enabled on the server yet. Ask your admin to run scripts/bagtag-join-requests.sql in Supabase (after bagtag-join-live-delete.sql).';
  }
  if (isMissingLiveDeleteJoin(msg)) {
    return 'Join is not enabled on the server yet. Ask your admin to run scripts/bagtag-join-live-delete.sql in Supabase.';
  }
  if (msg.includes('row-level security') || msg.includes('permission denied') || msg.includes('new row violates')) {
    if (isMissingJoinRequests(msg)) {
      return 'Could not join — run scripts/bagtag-join-requests.sql in Supabase.';
    }
    return 'Could not join — server permissions may need updating. Ask your admin to run scripts/bagtag-join-live-delete.sql (and bagtag-join-requests.sql for request-to-join).';
  }
  return rpcMessage || fallbackMessage || 'Could not join';
}

export function formatDeleteRoundError(message: string | undefined): string {
  const msg = lower(message);
  if (
    msg.includes('row-level security')
    || msg.includes('permission denied')
    || msg.includes('violates')
    || msg.includes('gr_delete')
  ) {
    return 'Could not delete — server permissions may need updating. Ask your admin to run scripts/bagtag-join-live-delete.sql in Supabase.';
  }
  return message || 'Could not delete round';
}
